import { Injectable } from '@angular/core';
import { VesselInfoDetail } from '@app/domain/entities/vessel-info.entity';
import { VesselInfoRepository } from '@app/domain/repositories/vessel-info.repository';
import { map, Observable } from 'rxjs';
import { VesselInfoService } from '../api-clients/vessel-info.service';
import { VesselInfoMapper } from '../mappers/vessel-info.mapper';

@Injectable()
export class VesselInfoRepositoryImpl implements VesselInfoRepository {
  private readonly _mapper = new VesselInfoMapper();

  constructor(private readonly _vesselInfoService: VesselInfoService) {}

  getByVesselByShiftId(vesselByShiftId: number): Observable<VesselInfoDetail> {
    return this._vesselInfoService
      .getByVesselByShiftId(vesselByShiftId)
      .pipe(map(dto => this._mapper.toDomain(dto)));
  }
}
